import 'angular';

import { PurchaseVehicleRegistrationRequestsCtrl } from './vehicle-registration.purchase-requests.ajs';
import { VehicleRegistrationLookupsCtrl }          from './vehicle-registration.lookups.ajs';
import { VehicleRegistrationLookupsDirective }     from './vehicle-registration.lookups.directive.ajs';
import { VehicleRegistrationServiceAjs }           from './vehicle-registration.service.ajs';
import { VehicleRegistrationSettingsCtrl }         from './vehicle-registration.settings.ajs';
import { VehicleRegistrationsStates }              from './vehicle-registrations.states.ajs';
import { VehicleRegistrationStatusCtrl }           from './vehicle-registration.status.ajs';
import { VehicleRegistrationStatusDirective }      from './vehicle-registration.status.directive.ajs';
import { VehicleRegistrationTireDetailsCtrl }      from './vehicle-registration.tire-details.ajs';
import { VehicleRegistrationTireDirective }        from './vehicle-registration.tire.directive.ajs';

angular.module('workshop.vehicle-registrations', [])
  .config(VehicleRegistrationsStates)
  .controller('PurchaseVehicleRegistrationRequestsCtrl', PurchaseVehicleRegistrationRequestsCtrl)
  .controller('VehicleRegistrationLookupsCtrl', VehicleRegistrationLookupsCtrl)
  .controller('VehicleRegistrationTireDetailsCtrl', VehicleRegistrationTireDetailsCtrl)
  .controller('VehicleRegistrationSettingsCtrl', VehicleRegistrationSettingsCtrl)
  .controller('VehicleRegistrationStatusCtrl', VehicleRegistrationStatusCtrl)
  .directive('vehicleRegistrationLookups', VehicleRegistrationLookupsDirective)
  .directive('vehicleRegistrationStatus', VehicleRegistrationStatusDirective)
  .directive('vrTire', VehicleRegistrationTireDirective)
  .service('vehicleRegistrationApi', VehicleRegistrationServiceAjs);
